import { ActivityFilterKey } from '@gripp/shared-logic';
import { ActivitySearchInput, FilterType } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { FilterBar } from '../../shared/components/filter/filterBar';

interface ActivityFiltersProps {
  assetId?: string;
}

export const ActivityFilters = ({ assetId }: ActivityFiltersProps) => {
  const filterKey = assetId
    ? ActivityFilterKey.AssetActivity
    : ActivityFilterKey.Activity;

  return (
    <View style={styles.filtersContainer}>
      <View style={styles.activitySearchContainer}>
        <ActivitySearchInput filterKey={filterKey} />
      </View>
      <FilterBar
        filterButtonTypes={[
          FilterType.ACTIVITYGROUPS,
          FilterType.ACTIVITYTYPES,
          FilterType.ACTIVITYLABELS,
          FilterType.ACTIVITYDATE,
        ]}
        filterKey={filterKey}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  activitySearchContainer: {
    width: 200,
    marginRight: 20,
  },
});
